import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService
  ) { }

  // Inicio sesión
  public login(user: any) {

    let formData: FormData = new FormData();

    if (user.token === undefined) {
      // console.log('es un usuario normal');
      formData.append('user', user.user);
      formData.append('pssw', user.pssw);
    }
    else {
      // console.log('es un usuario google');
      formData.append('user', user.email);
      formData.append('name', user.name);
      formData.append('image', user.image);
      formData.append('token', user.token);
      formData.append('id', user.id);
    }

    return this.http.post(this._apiRestService.APIURL.login, formData)
      // return this.http.get('assets/data/pruebaCurrentUser.json')
      .pipe(map((res: Response) => {
        return res;
      }))
  }

  // cierra sesión en el servidor/ actualiza el usuario conectado a 'annm'
  logout() {
    return this.http.get(this._apiRestService.APIURL.logout)
      .pipe(map
        (res => {
          return res
        }));
  }

  // el servidor devuelve el usuario actual, en caso de ser 'annm', quiere decir que no hay usuario actual
  currentUser() {
    return this.http.get(this._apiRestService.APIURL.currentUser);
  }

}